import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from "./navbar/navbar.component";
import { PageComponent } from './page/page.component';
import { FormsModule } from "@angular/forms";
import { HighlightModule } from "ngx-highlightjs";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HighlightModule
    ],
    declarations: [
        NavbarComponent,
        PageComponent
    ],
    exports: [
        NavbarComponent
    ]
})
export class CoreModule {
}
